// @ts-nocheck
import AsyncSelect from "react-select/async";
import * as React from "react";
import {useState, useEffect} from "react";
import {Button, InputAdornment, Tab, Tabs, TextField, List, ListItemButton} from "@mui/material";
import styled from "styled-components/macro";
import Box from "@mui/material/Box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBlender, faPlus, faTimes, faSearch} from "@fortawesome/pro-light-svg-icons";
import Modal from "@mui/material/Modal";
import {useDispatch, useSelector} from "react-redux";
import {selectVoices, selectTtsVoices, selectPublicVoices, selectIsLoading} from "app/pages/VoiceModelsPage/slice/selectors";
import {DotSpinner} from "@uiball/loaders";
import {faPlay, faPause, faMicrophoneStand, faExclamationTriangle} from "@fortawesome/pro-solid-svg-icons";
import {DisplaySongInfo} from "app/components/GlobalAudioPlayer/slice/types";
import {useGlobalAudioSlice} from "app/components/GlobalAudioPlayer/slice";
import {selectCurrentSong, selectIsPlaying} from "app/components/GlobalAudioPlayer/slice/selectors";
import emptyStateGraphic from "../../assets/AstronautSinging.png";
import {useNavigate} from "react-router-dom";
import saxolinImg from "../../assets/SaxolinTransparent.png";
import saxolinBg from "../../assets/SaxolinEmptyBG.png";
import violinImg from "../../assets/ViolinTransparent.png";
import violinBg from "../../assets/ViolinEmptyBG.png";
import saxophoneImg from "../../assets/SaxophoneTransparent.png";
import talkboxImg from "../../assets/TalkboxImage.png";
import { useMediaQuery } from '@mui/material';
import { Pulsar, Jelly } from "@uiball/loaders";
import { Link } from 'react-router-dom';
import { useFeatureFlagVariantKey } from 'posthog-js/react'
import {SearchBar} from "app/components/SearchBar";

// modal position/sizing
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(min(100vw, 800px))',
    bgcolor: 'background.paper',
    border: '1px solid #FF74E9',
    borderRadius: '20px',
    boxShadow: 24,
};
const mobileStyleOverride = {
    height: '100%',
}

export const INSTRUMENTS = [
    {
        id: 2690,
        name: 'Violin',
        description: "Diva wails teetering between passion and mischief",
        image_url: "https://storage.googleapis.com/controlla-public-images/Violin.jpg",
        instrumentImg: violinImg,
        backgroundImg: violinBg,
    },
    {
        id: 2693,
        name: 'Tenor Saxophone',
        description: "A velvety growl, with a resonating whisper",
        image_url: "https://storage.googleapis.com/controlla-public-images/Saxophone.jpg",
        instrumentImg: saxophoneImg,
        backgroundImg: saxolinBg,
    },
    {
        id: 2701,
        name: 'Saxolin',
        description: "Delicate weeps of ancient love and anger",
        image_url: "https://storage.googleapis.com/controlla-public-images/Saxolin.png",
        instrumentImg: saxolinImg,
        backgroundImg: saxolinBg,
    },
    {
        id: 13265,
        name: 'Talkbox',
        description: "A magical fusion of vocal breath and electric energy",
        image_url: "https://storage.googleapis.com/controlla-public-images/Talkbox.jpg",
        instrumentImg: talkboxImg,
        backgroundImg: saxolinBg,
    },
    {
        id: 15053,
        name: 'Trumpet',
        description: "Metallic cries slicing through silence like thunderclaps",
        image_url: "https://storage.googleapis.com/controlla-public-images/trumpet.jpeg",
        instrumentImg: talkboxImg,
        backgroundImg: saxolinBg,
    },
    {
        id: 15054,
        name: 'Electric Funk Guitar',
        description: "Funky plucks with a gritty, pulsing energy",
        image_url: "https://storage.googleapis.com/controlla-public-images/electric_funk_guitar.jpeg",
        instrumentImg: talkboxImg,
        backgroundImg: saxolinBg,
    },
    {
        id: 15056,
        name: 'Bansari Flute',
        description: "A soft, ethereal breeze with a mystical quality",
        image_url: "https://storage.googleapis.com/controlla-public-images/bansari_flute.jpeg",
        instrumentImg: talkboxImg,
        backgroundImg: saxolinBg,
    }
]


function VoiceModelList (props: { voices: any, onSelect: any, onPlay: any, onPause: any, isUserVoices: boolean }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { actions: globalAudioActions } = useGlobalAudioSlice()
    const currentSong = useSelector(selectCurrentSong)
    const isPlaying = useSelector(selectIsPlaying)

    // PostHog A/B test for empty state image
    const posthogVariant = useFeatureFlagVariantKey('empty-state-spaceman-image-test')

    if (props.voices.length == 0) {
        return (
            <EmptyStateContainer>
                <Graphic>
                    {posthogVariant === 'new-pic' ? (
                        <img src="https://storage.googleapis.com/controlla-public-images/empty%20state%20astronaut1.png" alt="Astronaut" style={{width: '100%', height: '100%'}} />
                    ) : (
                        <img src={emptyStateGraphic} alt="Astronaut singing" style={{width: '70%', height: '70%'}}/>
                    )}
                </Graphic>
                    <p> You haven't created any custom voices yet. </p>


                    <button className="primary-button small" onClick={() => navigate('/app/train')}>
                        Create your first voice
                    </button>

            </EmptyStateContainer>
        )
    }

    const renderStatusContent = (v) => {
        if (v.Jobs?.status === "PENDING") {
          return (
            <StatusContainer>
              <StatusText>Waiting for Payment/Credits</StatusText>
              <Pulsar size={18} speed={2} color="#F5E1FF" />
              <Link to="/refill" style={{color: '#55CDC4', marginLeft: '8px'}}>{'(Buy Voices)'}</Link>
            </StatusContainer>
          );
        }
        
        if (v.Jobs?.status === "CREATED") {
          return (
            <StatusContainer>
              <StatusText>Queued for cloning </StatusText>
              <Pulsar size={18} speed={2} color="#F5E1FF" />
            </StatusContainer>
          );
        }
        
        if (v.Jobs?.status === "STARTED") {
          return (
            <StatusContainer>
              <StatusText>Cloning in progress </StatusText>
              <Jelly size={18} speed={0.9} color="#FF74E9" />
            </StatusContainer>
          );
        }
        
        if (v.Jobs?.status === "FAILED") {
          let errorCode = v.Jobs?.func_results?.error_code;
          let errorMessage = "Failed ";
        //   if (errorCode === "NO_FILE") {
        //     errorMessage = "Failed to retrieve audio file";
        //   } else if (errorCode === "SILENT_FILE") {
        //     errorMessage = "Audio file is silent or too quiet";
        //   }
          return (
            <StatusContainer>
              <StatusText>{errorMessage}</StatusText>
              <FontAwesomeIcon icon={faExclamationTriangle} color={'#FF74E9'} />
            </StatusContainer>
          );
        }
    
        return null;
      };

    return <VoiceModelListContainer>
        {props.voices.map((v) => {
            const isVoiceReady = !v.Jobs || (v.Jobs && v.Jobs.status === 'COMPLETED');

            let playButtonEl = null
            const previewAudioUrl = v.AudioFiles?.storagePublicUrl

            if (previewAudioUrl) {
                const playButton = (
                    <VoicePreviewPlayButton onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        props.onPlay(v.image_url, v.name, previewAudioUrl)
                    }}>
                        <FontAwesomeIcon icon={faPlay} style={{fontSize: '25px'}}/>
                    </VoicePreviewPlayButton>
                )

                const pauseButton = (
                    <VoicePreviewPlayButton onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        props.onPause()
                    }}>
                        <FontAwesomeIcon icon={faPause} style={{fontSize: '25px'}}/>
                    </VoicePreviewPlayButton>
                )

                if (isPlaying && currentSong?.url === previewAudioUrl) playButtonEl = pauseButton
                else playButtonEl = playButton
            }

            return <VoiceListItem 
                onClick={() => isVoiceReady && props.onSelect(v)} 
                style={{ opacity: isVoiceReady ? 1 : 0.5, pointerEvents: isVoiceReady ? 'auto' : 'none', }}
                nameOnly={!!props.isUserVoices}
            >
                <VoiceThumbnailRow>
                    {!props.isUserVoices && (
                        <ThumbnailImageContainer>
                            {playButtonEl}
                            <ThumbnailImage src={v.image_url} />
                        </ThumbnailImageContainer>
                    )}
                    <VoiceInfoCol>
                        <VoiceName>
                            {v.name}
                        </VoiceName>
                        {!props.isUserVoices && (
                            <VoiceDescription>
                                {v.description}
                            </VoiceDescription>
                        )}
                        {!props.isUserVoices && v.tags && (
                            <VoiceTags>
                                {v.tags.map(t => (
                                    <VoiceTag>{t}</VoiceTag>
                                ))}
                            </VoiceTags>
                        )}
                        {props.isUserVoices && !isVoiceReady && (
                            renderStatusContent(v)
                        )}
                    </VoiceInfoCol>
                </VoiceThumbnailRow>
            </VoiceListItem>
        })}
    </VoiceModelListContainer>
}

export function VoiceSelectButtonModal(props: {
    buttonStyles: any, small: boolean | undefined, isTts: boolean | undefined, value: any, loading: any, onChange: (o) => void, optionLabel: (voice) => any, optionValue: (voice) => any
}) {

    const voices = useSelector(selectVoices);
    const ttsVoices = useSelector(selectTtsVoices);
    const voiceModels = (props.isTts ? ttsVoices : voices) || [];
    const publicVoiceModels = useSelector(selectPublicVoices);
    const isLoading = useSelector(selectIsLoading);
    const dispatch = useDispatch();
    const { actions: globalAudioActions } = useGlobalAudioSlice()
    const currentSong = useSelector(selectCurrentSong)
    const isPlaying = useSelector(selectIsPlaying)
    const [hasVoicePreviewPlayed, setHasVoicePreviewPlayed] = useState(false)
    const isMobile = useMediaQuery('(max-width: 600px)')

    // Is the selection model open?
    const [isOpen, setIsOpen] = useState(false)
    const [searchQuery, setSearchQuery] = useState("")

    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTabIndex(newValue);
        setSearchQuery(""); // Clear search when changing tabs
    };

    // Filter function for searching voices
    const filterVoices = (voices, query) => {
        if (!query.trim()) return voices;
        
        const searchTerm = query.toLowerCase();
        return voices.filter(voice => {
            // Search in name
            if (voice.name?.toLowerCase().includes(searchTerm)) return true;
            
            // Search in description
            if (voice.description?.toLowerCase().includes(searchTerm)) return true;
            
            // Search in tags
            if (voice.tags?.some(tag => tag.toLowerCase().includes(searchTerm))) return true;
            
            return false;
        });
    };

    // Get filtered voices based on current tab and search query
    const getFilteredVoices = () => {
        switch (currentTabIndex) {
            case 0: // Royalty Free Voices
                return filterVoices(publicVoiceModels, searchQuery);
            case 1: // My Voices
                return filterVoices(voiceModels, searchQuery);
            case 2: // Instruments
                return filterVoices(INSTRUMENTS, searchQuery);
            default:
                return [];
        }
    };

    useEffect(() => {
        if (voiceModels.length > 0) {
            setCurrentTabIndex(1)
        }
    }, [voiceModels])

    const handleOpen = () => {
        setIsOpen(true)
    }
    const handleClose = () => {
        setIsOpen(false)
        // in case a song is playing in bg, only stop and hide player if we are playing voice preview
        if (hasVoicePreviewPlayed) {
            dispatch(globalAudioActions.setCurrentSong(null))
            dispatch(globalAudioActions.setIsPlaying(false))
        }
    }

    const handlePlay = (imageUrl, singerName, audioPreviewUrl) => {

        setHasVoicePreviewPlayed(true)

        // Create DisplaySong object for main preview
        const displaySong :DisplaySongInfo = {
            title: "Voice Preview",
            singer: singerName,
            url: audioPreviewUrl,
            coverUrl: imageUrl,
        }

        dispatch(globalAudioActions.setCurrentSong(displaySong))
        dispatch(globalAudioActions.setIsPlaying(true))
    }

    const handlePause = () => {
        dispatch(globalAudioActions.setIsPlaying(false))
    }

    const handleSelect = (voice) => {
        console.log('select: ', voice)
        props.onChange(voice)
        handleClose()
    }

    const isSizeSmall = (props.small === true);

    // If no voices available after loading
    let showEmptyState = false
    if ((!props.defaultOptions || props.defaultOptions?.length === 0) && !props.loading) {
        showEmptyState = true
    }

    return <>
        <Button startIcon={<FontAwesomeIcon icon={faMicrophoneStand} size="1x" style={{fontSize: '16px', marginRight: '6px'}} />} sx={{ zIndex: 1, textOverflow: 'ellipsis', whiteSpace: "nowrap", overflow: "hidden", ...props.buttonStyles }} size="large" variant="outlined" onClick={handleOpen}>
            {props.value?.name || "Select Voice or Instrument"}
        </Button>
        {isOpen && (
            <Modal
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={isMobile ? {...style, ...mobileStyleOverride} : style}>
                    <ModalContent>
                        <ModalHeader>
                            <h2>
                                Select a voice
                            </h2>
                            <FontAwesomeIcon icon={faTimes} onClick={handleClose} size={"xs"} />
                        </ModalHeader>
                        <Tabs value={currentTabIndex} onChange={handleChangeTab} aria-label="Select a tab" variant="scrollable">
                            <Tab label="Royalty Free Voices" />
                            <Tab label="My Voices" />
                            <Tab label="Instruments" />
                        </Tabs>
                        
                        <SearchBar
                            placeholder="Search voices, descriptions, or tags..."
                            value={searchQuery}
                            onChange={setSearchQuery}
                        />
                        
                        {!isLoading && currentTabIndex === 0 && (
                            <VoiceModelList voices={getFilteredVoices()} onSelect={handleSelect} onPlay={handlePlay} onPause={handlePause}/>
                        )}
                        {!isLoading && currentTabIndex === 1 && (
                            <VoiceModelList voices={getFilteredVoices()} onSelect={handleSelect} isUserVoices={true} />
                        )}
                        {currentTabIndex === 2 && (
                            <VoiceModelList voices={getFilteredVoices()} onSelect={handleSelect} />
                        )}
                        {isLoading && (
                            <LoadingContainer>
                                <DotSpinner
                                    size={40}
                                    lineWeight={3.5}
                                    speed={1}
                                    color="#ff74e9"
                                />
                            </LoadingContainer>
                        )}
                    </ModalContent>
                    <ModalFooter>
                    </ModalFooter>
                </Box>
            </Modal>
        )}
    </>
}

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  padding-top: 32px;
  padding-right: 16px;
  padding-left: 16px;
  
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  position: relative;
  padding-right: 32px;
  padding-left: 32px;
  padding-bottom: 32px;

  border-radius: 20px;
  overflow: visible;
  min-height: 400px;

  @media only screen and (max-width: 600px) {
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 16px;

    height: 100dvh;
  }
`;

const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  padding-right: 32px;
  padding-left: 32px;
`;

const VoiceModelListContainer = styled(List)`
  height: calc(min(80vh, 500px));
  overflow-y: auto;
  position: relative;
  margin-top: 0px !important;
  padding-top: 0px !important;
  @media (max-width: 600px) {
    height: 80vh;
  }
`;

const VoiceListItem = styled.button<{ nameOnly?: boolean }>`
  border: none;
  background-color: #251A30;
  border-radius: 15px;
  padding: ${({ nameOnly }) => (nameOnly ? '25px' : '10px')};
  margin-top: ${({ nameOnly }) => (nameOnly ? '0px' : '8px')};
  width: 100%;
  align-items: center;
  color: #FFFFFF;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: #362749;
  }

  @media only screen and (max-width: 600px) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
`
const VoiceThumbnailRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`
const ThumbnailImageContainer = styled.div`
  width: 85px;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: center;
  border-radius: 10px;
  position: relative;
  overflow: hidden;

  @media only screen and (max-width: 600px) {
    width: 90px;
    align-self: flex-start;
  }
`;

const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const VoiceInfoCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-shrink: 1;
  width: 100%;
`

const VoiceName = styled.p`
  font-size: 20px;
  font-weight: 600;
  font-family: 'Raleway', sans-serif;
  color: #FFFFFF;
  margin: 15px;
  margin-top: 0px;
  margin-bottom: 0px;

  @media only screen and (max-width: 600px) {
    font-size: 20px;
  }
`;

const VoiceDescription = styled.p`
  color: #FFF;
  font-family: Raleway;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin-top: 0px;
  margin-left: 15px;
  margin-bottom: 8px;
  text-align: left;
  color: #f5e1ff;

  @media only screen and (max-width: 600px) {
    font-size: 12px;
    white-space: wrap;
  }
`;

const VoiceTags = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 15px;


  @media only screen and (max-width: 600px) {
    margin-left: 10px;
    flex-wrap: wrap;
  }
`

const VoiceTag = styled.div`
  color: #f5e1ff;
  font-family: Raleway;
  font-size: 12px;
  font-style: normal;
  font-weight: lighter;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 4px 10px;
  background: rgba(100, 82, 112, 0.30);
  border-radius: 0.9375rem;

  @media only screen and (max-width: 600px) {
    font-size: 12px;
    margin-top: 0px;
    margin-left: 1px;
    margin-bottom: 5px;
    padding: 4px 6px;
  }
  
`;

const LoadingContainer = styled.div`
  margin: auto;    
`

const VoicePreviewPlayButton = styled.button`
  position: absolute;
  width: 100%;
  height: 100%;
  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  background: none;
  outline: none;
  border: none;

  color: #FFF;
  text-align: center;
  text-overflow: ellipsis;
  font-family: Raleway;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  
  
  .fa-play {
  }
  
  &:hover {
    background:rgba(24, 13, 35, 0.4);

    .fa-play {
      color: #ff74e9;
    }
  }
`;

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  box-sizing: content-box;

  & p {
    text-align: center;
    margin: 10px;
  }
`;

const Graphic = styled.div`
  max-height: 300px;
  max-width: 300px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;

  & img {
    max-width:100%;
    max-height: 100%;
  }
`;

const StatusContainer = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  color: #F5E1FF;
  @media only screen and (max-width: 600px) {
    top: 16px;
    left: 36px;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

const StatusText = styled.span`
  font-family: 'Raleway', sans-serif;
  font-style: italic;
  font-size: 14px;
`;